import {useCallback} from 'react';
import {flushSync} from 'react-dom';
import {useFormContext} from 'react-hook-form';
import {FormFieldValues} from '@/constants/help';
import {useFocusElement} from '@/hooks/help/useFocusElement';

export const useFormClear = () => {
  const {setValue, clearErrors} = useFormContext();
  const {focusElement} = useFocusElement();

  const handleClear = useCallback(
    (fieldName: FormFieldValues, options?: {shouldFocus?: boolean}) => {
      flushSync(() => {
        setValue(fieldName, '');
        clearErrors(fieldName);
      });

      // 포커스 옵션이 true인 경우 해당 필드로 포커스 이동
      if (options?.shouldFocus) {
        focusElement(`input[name="${fieldName}"]`);
      }
    },
    [setValue, clearErrors, focusElement],
  );

  return {handleClear};
};
